var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEgypt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 8h30v8H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#be2a2c",
    d: "M30 8H0V0h30z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M30 24H0v-8h30z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#bf9300",
    d: "M12.48 15.01s.01.22.2.32c0 0-.05.16.14.25.2.1.92.24 2.16.24s1.94-.13 2.13-.22c.18-.1.2-.3.2-.3s.2-.11.18-.25c-.01-.13-.28-.27-.28-.27s-.06-.18-.25-.24c-.18-.07-.78.29-1.92.24-1.13-.06-1.78-.23-2-.21-.2 0-.3.22-.3.22s-.23.1-.26.22"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    d: "M12.63 15c-.01.08.16.25.16.25s0 .2.17.25c.17.06.87.19 2 .18a8 8 0 0 0 2.04-.16c.1-.08.17-.25.17-.25s.19-.14.18-.24-.28-.17-.28-.17-.08-.16-.16-.23c-.1-.07-.66.26-1.88.26-1.19 0-1.87-.29-2-.27-.11.01-.2.24-.2.24s-.2.05-.2.14"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#bf9300",
    d: "M17.65 9.87s-.03-.62-.6-.54-.6.36-1.21.42l-.13.01a3 3 0 0 1-.16-.85c0-.4.12-.57-.3-.77-.4-.2-.48-.01-.48-.01s-.32-.16-.47-.04-.06.42 0 .33c.07-.1.33.17.33.17.1.44-.16.91-.34 1.18l-.17-.02c-.6-.06-.65-.34-1.22-.42s-.6.54-.6.54l-.22 4.8.47-.36v-.05l.96-.86.16-.16-.4 1.17s-.6-.04-.43.45c0 0 .09-.28.25-.23l.62.17.16.25.2-.18.62-.03s.2.05.18.23a.4.4 0 0 0 .03-.24l.2-.02q-.04.14.02.26c-.01-.17.19-.23.19-.23l.62.03.2.18.15-.25.62-.17c.16-.05.26.23.26.23.17-.5-.44-.45-.44-.45l-.38-1.11.1.1.97.86v.05l.46.36zm-2.63 2.91c-.95-.59-1.03-2.07-1.03-2.07s.59-.04 1.02-.34c.38.35 1.04.3 1.04.3s-.04 1.5-1.03 2.11m2.18-3.1-.8.77-.14.06c-.14 0-.82 0-1.24-.37-.53.37-1.26.4-1.26.4l-.1-.05-.9-.8-.24.1c.01-.1.07-.32.36-.27.47.06.67.33 1.17.38l.15.01-.05.07c.07 0 .19-.03.27-.04h.1l-.04.16.24-.13.22.02.05.07.17-.09h.11l.24.1.03-.13c.12.08.31.08.31.08l-.07-.11.13-.01c.5-.06.7-.32 1.17-.39.3-.04.35.18.36.27z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    d: "m14.7 12.75-.47 1.81-.8-.15.82-2.33zm.6 0 .47 1.81.8-.15-.83-2.33z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#bf9300",
    d: "M14.19 10.85s.06.77.4 1.36v-1.53s-.22.13-.4.17m1.65.03s-.07.76-.41 1.36V10.7s.22.13.4.17"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    d: "M14.35 8.26s.09-.1.35.1l.33.2s.1-.11.26-.09.07.25.1.71c.03.47.21.66.21.66l-.22-.13.01.15-.25-.12-.12.17-.12-.19-.2.12-.05-.16-.23.12s.33-.4.36-.86l-.03-.43s-.2-.27-.4-.25"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#bf9300",
    d: "M13.16 15.1c-.16.08-.1.14 0 .18.09.04.64.1 1.77.13 1.15.03 1.86-.1 1.95-.16.1-.05.1-.14-.05-.17s-.95.1-1.92.1c-1.19 0-1.69-.13-1.75-.09"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEgypt);
export default __webpack_public_path__ + "static/media/egypt.b0c778e0cf2910dd1a683b3e835e6671.svg";
export { ForwardRef as ReactComponent };